export default {
    yes: "Yes",
    no: "No"
}
